import { gql } from '@apollo/client';

export const GET_PRINTERS_QUERY = gql`
  query printers {
    printers {
      id
      name
      code
      brand
      ipAddress
      slug
      bdAddress
      series
      printerType
    }
  }
`;
